import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedConsts } from 'src/app/shared/constants';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { CartService } from '../../services/cart.service';

@Component({
    selector: 'app-card-payment-success',
    templateUrl: './card-payment-success.component.html',
    styleUrls: ['./card-payment-success.component.scss'],
    standalone: false
})
export class CardPaymentSuccessComponent implements OnInit {

  public windowUrl: any;
  orderDetail: any;
  gateway_token: any;
  global_data:any ={};
  
  constructor(private router: Router, private activeRouter: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService, private cartService: CartService,
    private alertService: AlertService, private statePersist: StatePersistService) {
      this.gateway_token = this.activeRouter.snapshot.queryParamMap.get('gateway_token')
      this.router.navigate([], {
        queryParams: {
          'gateway_token': null,
          },
        queryParamsHandling: 'merge'
      })
     }

  ngOnInit(): void {
    let url='/mycart/payment/card-payment/success?gateway_token='+this.gateway_token
   
    window.opener.location.href = url
    window.opener.focus()
    window.top.close();
    this.checkoutDetail()
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })

  }

  checkoutDetail(){
    this.cartService.checkoutDetail()
    .subscribe(
      response => {
        if (response.status == 2212){
          this.alertService.error(response.response)
        }
          this.orderDetail = response.response
        },
        error => { }
    )
  }

  payment(){
    this.placeOrder('gateway_token', this.gateway_token, '')
  }

  placeOrder(flag, token, savecard){
    this.cartService.placeOrder('', flag, token, savecard, '','','')
    .subscribe(
      response => {

        if (response.status == 1161 || response.status ==1153 || response.status == 2215){
          this.alertService.error(response.response)
          this.router.navigate(['/'])
        }
        else if (response.status == 403){
          this.router.navigate(['/'])
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1157){
          this.alertService.error(response.response)
          this.router.navigate(['/'])
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1180){
            localStorage.setItem('closeStorInfoMessage', response.response.msg)
            document.getElementById("openclosedStoreInfo").click();
            this.router.navigate(['/'])
            document.body.classList.remove("saved-payment-box");
            document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1199){
          this.windowUrl = window.open(response.response);
        }
        else{
          this.orderDetail['order_id'] = response.response.order_id
          this.orderDetail['order_date'] = response.response.order_date
          this.orderDetail['grand_total'] = response.response.grand_total 
          this.orderDetail["transaction_payment_id"] = response.response.transaction_payment_id 
          this.orderDetail['transaction_date'] = response.response.transaction_date
          this.orderDetail['price_visibility'] = this.global_data['price_visibility']
          this.orderDetail['card_payment'] = 1
          this.statePersist.setLocalStorage('order-detail', this.orderDetail)
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
          if (response.response.redirect_url != ''){
            window.location.replace(response.response.redirect_url)
            
          }
          else{
            this.googleAnalyticsService.eventEmitter(SharedConsts.PLACE_ORDER_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PLACE_ORDER_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
            this.router.navigate(['mycart/order-confirmation'])
          }
          
          
        }
        
        },
        error => { }
    )
    

  }

}
